import React, { memo } from 'react';

import NextImage from 'next/image';

declare const zonePathGlobal: string;

export interface ImageProps {
  name: string;
  alt: string;
  width: string | number;
  height: string | number;
  layout?: 'fixed' | 'fill' | 'intrinsic' | 'responsive';
  objectFit?:
    | '-moz-initial'
    | 'inherit'
    | 'initial'
    | 'revert'
    | 'unset'
    | 'contain'
    | 'cover'
    | 'fill'
    | 'none'
    | 'scale-down';
}

export const Image = memo(
  ({ name, alt, width, height, layout = 'fixed', objectFit = 'contain' }: ImageProps) => (
    <NextImage
      src={`${zonePathGlobal}/cp_assets/images/${name}`}
      alt={alt}
      width={width}
      height={height}
      layout={layout}
      objectFit={objectFit}
    />
  ),
);

Image.displayName = 'Image';
